import React from 'react'
import Numeral from 'numeral'

import { Bar } from 'recharts'

import transform from '../transform'
import colors from 'lib/colors'

import Empty from 'components/charts/empty'
import ChartContainer from 'components/charts/container'
import { APPSYNC_RESOLVER_REQUESTS } from 'containers/inventory/details/resource/metrics-tabs/services/appsync-resolver'

const AppSyncResolverRequestsChart = ({ loading, data, height, span }) => {
  if (loading || !data) return null

  const metrics = transform({
    [APPSYNC_RESOLVER_REQUESTS]: data.APPSYNC_RESOLVER_REQUESTS
  })
  if (!metrics.length) return <Empty height={height} />

  const tooltipFormatter = (value, name, props) => {
    return [Numeral(value).format('0.[000]a'), undefined]
  }

  return (
    <ChartContainer height={height}
      data={metrics}
      yTicksFormatting='0 a'
      span={span}
      tabKey={APPSYNC_RESOLVER_REQUESTS}
      formatTab={value => `${Numeral(value).format('0.[000]a')}`}
      formatTooltip={tooltipFormatter}
    >
      <Bar dataKey={APPSYNC_RESOLVER_REQUESTS} stackId='a' fill={colors('chart', 'primary')} name='Requests' barSize={4} />
    </ChartContainer>
  )
}

export default AppSyncResolverRequestsChart
